/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * AccountInfo Footer Actions
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.11.0
 */

import styled from 'styled-components';

import { TABLE_FOOTER_BOTTOM_STYLE } from '../../../../components/Table/constants';
import { colors } from '../../../../theme';

export const PageCardFooterStyled = styled.div.attrs({
    'className': 'account-info-footer fixed-with-scrollbar',
    'data-name': 'account-info-footer',
})`
    position: fixed;
    right: 0;
    left: 0;
    bottom: ${TABLE_FOOTER_BOTTOM_STYLE}px;
    width: 100%;
    z-index: 500;
    margin-bottom: 0;

    background: ${colors.tableFooterBgColor};
`;
